import { FormSectionElements, FormSections, ProgramContainer, SummaryStyleType } from "../../entities/formTemplateDataType";
import Card from "../card";
import { InfoElementComponent } from "./InfoElementComponent";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import StepIndicator from "../subComponent/step-indicator/StepIndicator";
import { CheckboxComponent } from "../subComponent/CheckboxComponent";
import { RichTextComponent } from "../subComponent/RichTextComponent";
import { SpinnerComponent } from "../../commonComponent/SpinnerComponent";
import { ErrorAlertsComponent } from "../odsCalloutBox/ErrorAlertsComponent";
import DynamicComponentRenderer from "../../DynamicComponentRenderer";
import React from "react";
import { SubSectionComponent } from "../SubSectionComponent";
import { TableMenuComponent } from "../subComponent/TableMenuComponent";
import { USER_PROFILE } from "../../entities/Constants";
import { getSubSectionButton } from "../../utilities/ElementUtils";
import { ReactComponent as EditIcon } from "../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-edit.svg";
import TableSummaryComponent from "./TableSummaryComponent";
import { sum } from "lodash";


interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  activesteps: Set<number>;
  style?: SummaryStyleType;
  callback: (programContainer: ProgramContainer) => void;
  callbackStepIndex: (index: number) => void;
}

interface State {
  confirmationVisible: boolean
  summaryVisible: boolean
  transactionId: string;
  isBusy: boolean;
  validationErrMsg: any;
  submissionError: boolean;
  token: string;
  uploadReceiptSuccess: boolean
}

export class CustomizedSummaryComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      confirmationVisible: false,
      summaryVisible: true,
      transactionId: null,
      isBusy: false,
      validationErrMsg: [],
      submissionError: false,
      token: null,
      uploadReceiptSuccess: null
    }
  }

  componentDidMount() {
    console.log("componentDidMount")
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // }

  handleEditButtonClick = (field: FormSectionElements) => {
    if (field.Script) {
      const customJSFunc = eval(`(${field.Script})`);
      customJSFunc((index) => { this.props.callbackStepIndex(index) });
    }
    if (field.StepperScript) {
      const customJSFunc = eval(`(${field.StepperScript})`);
      customJSFunc((index) => { this.props.callbackStepIndex(index) });
    }
  }
  
  generateSummaryHtmlString = () => {
    if (!this.state.summaryVisible) return null;
    let SectionHtmlString = [];
    let sumStyle = '';

    const programContainer = this.props.programContainer;
    const sectionList = programContainer.ListOfFormSections.filter(p => p.CustomizedReviewPage);

    const stepNumer = Array.from(this.props.activesteps)[this.props.activesteps.size - 1]

    SectionHtmlString.push(<StepIndicator withbackbtn={true} title="Back" sectionSequence={stepNumer} isEng={this.props.isEng}
      totalSteps={this.props.activesteps} section={sectionList[0]}
      callback={currentStep => { this.props.callbackStepIndex(currentStep) }}>
    </StepIndicator>);

    SectionHtmlString.push(
      <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} ></ErrorAlertsComponent>
    )

    for (const section of sectionList) {
      SectionHtmlString.push(
        <div>
          <div className="ontario-h2 ontario-margin-bottom-24-!">{this.props.isEng ? section.ENUTitle : section.FRATitle}</div>
          <div className="ontario-margin-bottom-32-!">{this.props.isEng ? section.ENUDescription : section.FRADescription}</div>
        </div>
      );

      if (section.PreScript) {
        try {
          const customJSFunc = eval(`(${section.PreScript})`);
          customJSFunc(section);
        } catch (ex) {
          console.log(ex);
        }

      }

      const subsectionListInCard = section.ListOfFormSubSections.filter(p => p.NoCardInSummary !== true && p.Visible != false);
      for (const subSection of subsectionListInCard) {
        let fieldHtml = [];
        
        for (let field of subSection.ListOfFormSectionElements) {
          field.findFieldByName = (fieldName) => {
            const root = subSection.parent.parent;

            const formList = root.ListOfFormSections;
            let eleReturned;
            try {
              formList.forEach(section => {
                if (section.Visible == false) return;
                section.ListOfFormSubSections.forEach(sub => {
                  const elements = sub.ListOfFormSectionElements;
                  elements.forEach(ele => {
                    if (ele.LoadBindName == fieldName) {
                      eleReturned = ele;
                      throw new Error('Exit all loops');
                    }
                  })
                })
              });
            } catch {
              return eleReturned;
            }
            return null;
          }

          field.findSectionByTitle = (sectionTitle) => {
            const root = subSection.parent.parent;
            const formList = root.ListOfFormSections as FormSections[];
            for (let form of formList) {
              if (form.ENUTitle == sectionTitle) {
                return form;
              }
            }

            return null;
          }

          if (field.Datatype !== "Button" && field.Datatype != 'Label') {
            FormValidationUtils.runJavascript(field);
            if (!field.Visible) break;
            if (this.props.style === 'Table') {
              sumStyle = 'Table';
              fieldHtml.push(
                <TableSummaryComponent 
                  isEng={this.props.isEng}
                  field={field}
                  key={"table_sum" + field.Id}
                  withButton={field.Datatype != "Label"}
                  handleEditButtonClick={this.handleEditButtonClick}
                  callback={(programContainer) => this.props.callback(programContainer)}
                />
              )
            } else {
              fieldHtml.push(
                <InfoElementComponent
                  isEng={this.props.isEng}
                  field={field}
                  key={"infoelment_" + field.Id}
                  style={this.props.style}
                  withButton={field.Datatype != "Label"}
                  handleEditButtonClick={this.handleEditButtonClick}
                  callback={(programContainer) => this.props.callback(programContainer)}>
                </InfoElementComponent>
              );
            }
          } else {
            if (field.Datatype == "Button" && (!this.props.style || this.props.style === 'Button' || this.props.style === 'All')) {
              fieldHtml.push(<button className="ontario-button ontario-button--secondary" key={"elemnt_inf_button" + field.Id} 
                onClick={() => this.handleEditButtonClick(field)}
              >{this.props.isEng ? field.ENUTitle : field.FRATitle}</button>)
            }
            if (field.Datatype == 'Label') {
              fieldHtml.push(<RichTextComponent field={field}
                editable={true}
                title={this.props.isEng ? field.ENUTitle : field.FRATitle}
                labelControlArray={this.props.isEng ? field.ENUTitle : field.FRATitle}
                requiredField={false}
                callbackElement={null}
                isEng={this.props.isEng}></RichTextComponent>);
            }
          }
        }

        SectionHtmlString.push(
          <Card
            className={`inforCard ${sumStyle? 'notBordered': ''}`}
            title={this.props.isEng ? subSection.ENUTitle : subSection.FRATitle}
            content={
              <>
                {fieldHtml}
              </>
            }>
          </Card>
        );
      };
      const subsectionListNotInCard = section.ListOfFormSubSections.filter(p => p.NoCardInSummary && p.Visible != false);

      for (const subSection of subsectionListNotInCard) {
        subSection.ListOfFormSectionElements.sort((a, b) => a.Sequence - b.Sequence).forEach((element: FormSectionElements) => {
          switch (element.Datatype) {
            case "TableMenu":
              SectionHtmlString.push(
                <TableMenuComponent
                  field={element}
                  isEng={this.props.isEng}
                  callbackStepIndex={(index, returnIndex) => this.props.callbackStepIndex(index)}
                  callbackElement={(container) => { this.props.callback(container) }}>
                </TableMenuComponent>
              );
              break;
            case "Checkbox":
              const HtmlToReactParser = require('html-to-react').Parser;
              const htmlToReactParser = new HtmlToReactParser();
              SectionHtmlString.push(
                <CheckboxComponent field={element}
                  editable={true}
                  title={this.props.isEng ? element.ENUTitle : element.FRATitle}
                  labelControlArray={this.props.isEng ? (element.richTextChecked ? htmlToReactParser.parse(element.ENUTitle) : element.ENUTitle) : (element.richTextChecked ? htmlToReactParser.parse(element.FRATitle) : element.FRATitle)}
                  requiredField={true}
                  callbackElement={(container) => {
                    this.props.callback(container);
                  }}
                  isEng={this.props.isEng}
                  usedForFilter={false}
                  requiredLabel={false}
                  hint={null}></CheckboxComponent>
              )
              break;
            case "Label":
              SectionHtmlString.push(
                <RichTextComponent field={element}
                  editable={true}
                  title={this.props.isEng ? element.ENUTitle : element.FRATitle}
                  labelControlArray={this.props.isEng ? element.ENUTitle : element.FRATitle}
                  requiredField={false}
                  callbackElement={null}
                  isEng={this.props.isEng}></RichTextComponent>
              )
          }
        })
      }
    }
    const section = sectionList[0];
    let submitComponentName = "Submit";
    if (this.props.programContainer.CategoryId.toUpperCase() == "CHC") {
      submitComponentName = "CHCSubmit";
    }

    const props = {
      programContainer: this.props.programContainer,
      isEng: this.props.isEng,
      section: section
    };

    SectionHtmlString.push(
      <DynamicComponentRenderer componentName={submitComponentName} componentProps={props} callbackStepIndex={(index) => {
          console.log(index);
          this.props.callbackStepIndex(index);
        }}
        onButtonClick={(props) => {
          this.setState({
            isBusy: props.isBusy,
            confirmationVisible: props.confirmationVisible,
            summaryVisible: props.summaryVisible,
            transactionId: props.transactionId,
            uploadReceiptSuccess: props.uploadReceiptSuccess,
            submissionError: props.submissionError,
            validationErrMsg: props.validationErrMsg
          })
        }}
        callback={(programContainer) => this.props.callback(programContainer)}
      />);

    return SectionHtmlString;
  }

  generateConfirmationHtmlString = () => {
    const confirmationComponentName = this.props.programContainer.CategoryId.toUpperCase() + 'Confirmation';

    const props = {
      programContainer: this.props.programContainer,
      isEng: this.props.isEng,
      transactionId: this.state.transactionId,
      Visible: this.state.confirmationVisible,
      uploadReceiptSuccess: this.state.uploadReceiptSuccess
    }

    let SectionHtmlString = [];

    if (this.props.programContainer.CategoryId.toUpperCase() == 'CHC') {
      SectionHtmlString.push(
        <DynamicComponentRenderer componentName={confirmationComponentName} componentProps={props} onButtonClick={(p) => { }} />
      );
    } else {
      SectionHtmlString.push(this.state.confirmationVisible && this.generateGeneralConfirmationPage());
    }

    return SectionHtmlString;
  }

  handleBackButtonClick = (backToUrl) => {
    sessionStorage.removeItem(USER_PROFILE);
    const url = process.env.PUBLIC_CXP_WEB_BASE_PATH + '/auth/signin?redirectUrl=' + backToUrl;
    window.location.assign(url);
  }

  generateGeneralConfirmationPage() {
    let SectionHtmlString = [];
    const confirmationPageArray = this.props.programContainer.ListOfFormSections.filter(p => p.IsConfirmationPage);

    if (confirmationPageArray.length == 0) return null;

    const confirmationPage = confirmationPageArray[0];

    let backToLabel, backToUrl;
    if (this.props.programContainer.Profile?.email) {
      backToLabel = this.props.isEng ? "Back to home" : "Retour à l'accueil";
      backToUrl = this.props.isEng ? '/dashboard' : '/fr/dashboard'
    } else {
      backToLabel = this.props.isEng ? "Back to Ontario.ca" : "Revenir à Ontario.ca";
      backToUrl = this.props.isEng ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
    }

    if (this.props.programContainer.Profile?.email) {
      SectionHtmlString.push(
        <StepIndicator withbackbtn={true} title={backToLabel} 
          sectionSequence={0} section={confirmationPage} isEng={this.props.isEng} 
          customOnclick={() => this.handleBackButtonClick(backToUrl)} 
        />
      );
    } else {
      SectionHtmlString.push(
        <StepIndicator withbackbtn={true} title={backToLabel} 
          sectionSequence={0} section={confirmationPage} isEng={this.props.isEng} 
          // customOnclick={() => window.location.replace(backToUrl)} 
        />
      );
    }
    // SectionHtmlString.push(
    //   <StepIndicator withbackbtn={true} title='Back' sectionSequence={0} isEng={this.props.isEng} />
    // );

    for (let subSection of confirmationPage.ListOfFormSubSections) {
      SectionHtmlString.push(<SubSectionComponent key={'sub_' + subSection.Id + subSection.Id}
        isEng={this.props.isEng}
        activeSubSection={subSection}
        editable={false}
        callback={(programContainer) => {
          this.props.callback(programContainer)
        }} />)
    }

    return SectionHtmlString;
  }

  render() {

    let SectionHtmlString = [];

    SectionHtmlString.push(this.generateSummaryHtmlString());

    SectionHtmlString.push(this.generateConfirmationHtmlString());

    if (this.state.submissionError) {
      const techSection = FormValidationUtils.getTechSection(this.props.programContainer);
      techSection.Visible = true;
      const index = this.props.programContainer.ListOfFormSections.findIndex(p => p.IsTechErrorPage);
      this.props.callbackStepIndex(index);
    }

    SectionHtmlString.push(<SpinnerComponent isBusy={this.state.isBusy} />);

    return SectionHtmlString;
  }
}